import React from 'react';
import Dashboard from '../Dashboard';
import TravelInfoMain from './TravelInfoMain'

export default function TravelInfo() {
    return (
        <div>
            <Dashboard cmp={<TravelInfoMain />} />
        </div>
    )
}

